import axios from './axios'
import qs from "qs";

function service(endpoint) {

    function fetchOwn(data) {
        return axios.get(`${endpoint}/own`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchAccessible(data) {
        return axios.get(`${endpoint}/accessible`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function cancel(id) {
        return axios.post(`${endpoint}/${id}/cancel`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function settle(id) {
        return axios.post(`${endpoint}/${id}/settle`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function send(id) {
        return axios.post(`${endpoint}/${id}/send`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchOwn,
        fetchAccessible,
        cancel,
        settle,
        send
    }
}

export default service
